import { render, staticRenderFns } from "./ProjectNews.vue?vue&type=template&id=84ffe4a2&scoped=true&"
import script from "./projectnews.js?vue&type=script&lang=js&"
export * from "./projectnews.js?vue&type=script&lang=js&"
import style0 from "./ProjectNews.vue?vue&type=style&index=0&id=84ffe4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ffe4a2",
  null
  
)

export default component.exports